import React from "react";
import ProductsBags from '../products/productsBags';

function Products() {
  return (
    <>
      <ProductsBags />
    </>
  )  
}

export default Products;
